<script lang="ts" setup>
import { ref, watch } from 'vue';
import IconChevron from '~theme/components/atoms/icons/IconChevron.vue';

const props = withDefaults(
  defineProps<{
    isOpen?: boolean;
  }>(),
  {
    isOpen: false,
  }
);

const _isOpen = ref(false);

watch(
  () => props.isOpen,
  (value) => {
    _isOpen.value = value;
  }
);
</script>

<template>
  <div :class="$style.accordion">
    <div :class="$style.accordion__question" @click="_isOpen = !_isOpen">
      <div :class="$style.accordion__title">
        <slot />
      </div>
      <div :class="$style.accordion__icon">
        <IconChevron :direction="_isOpen ? 'up' : 'down'" />
      </div>
    </div>
    <Transition
      :enter-from-class="$style['slide-down-enter-from']"
      :enter-active-class="$style['slide-down-enter-active']"
      :enter-to-class="$style['slide-down-enter-to']"
      :leave-from-class="$style['slide-down-leave-from']"
      :leave-active-class="$style['slide-down-leave-active']"
      :leave-to-class="$style['slide-down-leave-to']"
    >
      <div v-show="_isOpen">
        <div :class="$style.accordion__content">
          <slot name="content" />
        </div>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" module>
.accordion {
  &__question {
    display: flex;
    justify-content: center;
    cursor: pointer;
  }

  &__title {
    flex-grow: 1;
  }

  &__icon {
    display: grid;
    place-items: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    margin-left: 12px;
    color: $color-text-and-object-medium-emphasis;
  }

  &__content {
    margin-top: 20px;
    padding: 20px;
    border-radius: 8px;
    background-color: $color-surface-secondary;
  }
}

.slide-down {
  &-enter-active,
  &-leave-active {
    transition: max-height 300ms ease-in-out;
  }

  &-enter-to,
  &-leave-from {
    overflow: hidden;
    max-height: 500px;
  }

  &-enter-from,
  &-leave-to {
    overflow: hidden;
    max-height: 0;
  }
}
</style>
